export const TableWrapperTestIds = {
  EXPAND_BUTTON: 'table-wrapper.expand-button',
};
